export const addNonBreakingSpaces = (text: string) => {
  return text.replace(/ ([\p{P}$%])/gu, '&nbsp;$1');
};
